<template>
  <div class="notifications-date">
    {{ formattedDate }}
  </div>
</template>

<script>
import moment from 'moment'

import { dateFormatter } from "../../helpers/formatters";

export default {
  props: {
    date: {
      default: '',
      type: String,
    },
  },
  computed: {
    formattedDate() {
      const today = moment()

      const currentDate = moment(this.date)

      if (currentDate.isSame(today, 'day')) {
        return 'Today'
      } else if (currentDate.isSame(today.clone().add(-1, 'day'), 'day')) {
        return 'Yesterday'
      }

      return dateFormatter({ date: currentDate, format: 'dddd, MMM D, YYYY' })
    },
  },
}
</script>

<style lang="scss" scoped>
.notifications-date {
  @include semi-bold-13-20;
  padding-left: 8px;
  margin-bottom: 8px;
  margin-top: 16px;

  &.first {
    margin-top: 0;
  }
}
</style>
